



























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/Card.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ForkMe from '@/components/ForkMe.vue';


@Component({
  components: {
    Card,
    FontAwesomeIcon,
    ForkMe,
  },
  head: {
    title: {
      inner: 'CV',
    },
  },
})
export default class Cv extends Vue {}
